module.exports = __webpack_public_path__ + "img/wgh.19c0e874.png";